import { BundleFilterOptions } from '@/api';

/** Sort bundleFilterOptions by displayType */
export const getSortedBundleFilterOptions = (bundleFilterOptions: BundleFilterOptions[]): BundleFilterOptions[] => {
  return [...bundleFilterOptions].sort((a, b) => {
    const order = { dates: 1, drop_down: 2, checkbox: 3 };
    return order[a.displayType] - order[b.displayType];
  });
};
